/*************
このファイルは convert-locales コマンドにより自動生成されたものです
修正するには大元のymlファイルを編集し、convert-locales コマンドを実行してください
*************/
export const en = {
  locale: 'en',
  messages: {
    'dialog.cancel': 'Cancel',
    'dialog.ok': 'OK',
    'deviceFamilyNames.0': 'iPhone',
    'deviceFamilyNames.1': 'iPad',
    'deviceFamilyNames.2': 'iPhone/iPad',
    'pullToRefresh.pullToRefresh': 'Reload',
    'pullToRefresh.releaseToRefresh': 'Reload',
    'pullToRefresh.refreshing': 'Reloading',
    'alert.error': 'Failed to connect. Please try again later.',
    'alert.startBinaryInstall':
      'Installation started. To see the progress, please go to the Home screen.',
    'prompt.inputDisplayName': 'Input new name',
    'confirm.leaveTest': 'Are you sure you want to leave this test?',
    'loginForm.submit': 'Login',
    'loginForm.email': 'Email',
    'loginForm.password': 'Password',
    'appFileInfo.releaseDate': 'Released',
    'appFileInfo.TTL': 'TTL',
    'appFileInfo.size': 'Size',
    'appFileInfo.compatibility': 'Compatibility',
    'appFileInfo.targetDeviceFamily': 'Targeted Device Family',
    'samlLoginForm.help': 'This feature is only for Enterprise plan.',
    'samlLoginForm.enterpriseName': 'Your enterprise name',
    'samlLoginForm.enterpriseNameFormat':
      'The name is consist of alphabet, numeric, hyphen and underscore only.',
    'samlLoginForm.submit': 'Login',
    'signUpForm.submit': 'Sign up',
    'signUpForm.email': 'Email',
    'signUpForm.password': 'Password',
    'signUpForm.username': 'Username (at least 3 characters)',
    'signUpForm.termsAccept':
      'I agree to the <terms>Terms of Service</terms> and <privacyPolicy>Privacy Policy</privacyPolicy>',
    'signUpForm.emailValidatedMessage': 'Your email address has been verified.',
    'signUpEmailForm.email': 'Email',
    'signUpEmailForm.help':
      'A send verification code will be sent to the email address you entered.',
    'signUpEmailForm.submit': 'Send verification code',
    'signUpValidateForm.code': 'Verification Code',
    'signUpValidateForm.sentMessage':
      'Sent verification code to your email address.',
    'signUpValidateForm.resend': 'Resend verification code',
    'signUpValidateForm.submit': 'Verification',
    'appInstall.version': 'Version',
    'appInstall.updatedAt': 'Last Update',
    'appInstall.overwriteInstall': 'Overwrite the App Store version',
    'appInstall.unsupportedOverwriteInstall':
      'Your current version of iOS {deviceOsVersion} does not support the overwriting of the App Store version.',
    'appInstall.install': 'Install',
    'appInstall.binaryOverSize':
      'Attention: Please download this app with wifi as it is over 100MB.',
    'appInstall.expiredProvisioningProfile.developer':
      "The app's provisioning profile has expired. To reactivate the app, please renew it and archive the app again.",
    'appInstall.expiredProvisioningProfile.tester':
      'The app has expired. Please contact the developer to update.',
    'appInstall.unsupportedDevice':
      'This version targets {targetDevice}. (Your device is an {currentDevice}.)',
    'appInstall.unsupportedOsVersion':
      'Target OS Version {minimumOsVersion}. (Your device is {deviceOsVersion}.)',
    'appInstall.notRegisteredIphone.developer':
      "This device's UDID is not included in the app's provisioning profile. To reactivate the app, please add the UDID to the provisioning profile of the app.",
    'appInstall.notRegisteredIphone.tester':
      'Please contact the developer to refresh the profile.',
    'appInstall.duplicateIconNotice':
      'You may see two app icons during the download if a previous version was already installed.',
    'appInstall.enterpriseAcceptProfile':
      'If you see an "Untrusted Enterprise Developer" error: open Settings app, go to General → Profiles, tap on the row {teamName}, and then Trust "{teamName}".',
    'appInstall.adhocEnableDeveloperMode':
      'To run this app, you need to enable "Developer Mode" on this device. To enable it, back to the home screen, go to Settings > Privacy & Security, scroll down and navigate into "Developer Mode". Then toggle the switch and follow the instructions.',
    'appDetail.releaseNote': 'Release Notes',
    'appDetail.info': 'Application Details',
    'appDetail.distributionUpdatedDate': 'Last Update',
    'commentDetail.reply': 'replied to {name}',
    'commentDetail.unknownUserName': 'Unknown user',
    'commentModal.placeholder.defult': 'Comment',
    'commentModal.placeholder.withReplyName': 'Replying to {name}',
    'commentModal.cancel': 'Cancel',
    'commentModal.submit': 'Post',
    'configurationProfileInfo.suggestUpdate':
      'The iOS version could not be obtained because the page is displayed using the desktop version of the website. Please <reInstallProfile>reinstall the profile</reInstallProfile> if your device’s iOS version is not {deviceOsVersion}.',
    'configurationProfileInfo.confirm.reInstall':
      'Are you sure you want to reinstall configuration profile?',
    'loginPage.nonAccountHolderNoticeTitle': 'Invitation Required',
    'loginPage.nonAccountHolderNoticeContent':
      "If you have a valid link (e.g.: a Distribution page's URL) or a QR code, please open the link or read the QR code to participate in app testing. Otherwise, please receive an invitation from the developers first.",
    'loginPageLayout.OAuthLogin.linkTitle': 'Sign in with GitHub or Google.',
    'loginPageLayout.OAuthLogin.github': 'Sign in with GitHub',
    'loginPageLayout.OAuthLogin.google': 'Sign in with Google',
    'loginPageLayout.SAML': 'Sign in with SAML Auth',
    'loginPageLayout.noAccount': "Don't have an account?",
    'loginPageLayout.reminder': 'Forgot your password?',
    'configurationProfilePageLayout.title': 'Install DeployGate',
    'configurationProfilePageLayout.deploygate': 'DeployGate',
    'configurationProfilePageLayout.help':
      "To use the app you've been invited to, please install DeployGate first.",
    'configurationProfilePageLayout.udidHelp':
      "Your device's UDID will be passed to the app developers.",
    'configurationProfilePageLayout.install': 'Install DeployGate',
    'configurationProfilePageLayout.guide1':
      'Once you install the profile at Settings, "DeployGate" will appear on your Home screen.',
    'configurationProfilePageLayout.guide2':
      'You can see the apps you are invited to on "DeployGate".',
    'configurationProfilePageLayout.logout': 'Log out',
    'configurationProfilePageLayout.installNotice':
      'Please open *Settings* to proceed with the installation after the profile is downloaded via the button above.',
    'signUpPageLayout.banner':
      "DeployGate properly manages your account information under GDPR, Japan's Personal Information Protection Act and our Privacy Policy.",
    'signUpPageLayout.login': 'Already have an account?',
    'appsPageLayout.title': 'Apps',
    'appsPageLayout.availableApps': 'Available Apps',
    'appsPageLayout.logout': 'Change User',
    'appsPageLayout.login': 'Login',
    'appsPageLayout.reInstall': 'Reinstall DeployGate',
    'appsPageLayout.noAvailableApps': 'Just a minute, developers working',
    'appsPageLayout.waitForEnginner':
      'Developers are working hard to build the app for your device. You will receive an email notification when it is ready.',
    'appsPageLayout.notificationSetting': 'Notification Setting',
    'appsPage.confirm.logout': 'Are you sure you want to log out?',
    'appsPage.confirm.reInstall':
      'Are you sure you want to reinstall DeployGate?',
    'appsPage.terms.title': 'Terms and Policies',
    'appDetailPageLayout.title': 'Install App',
    'appDetailPageLayout.otherVersions': 'Older Revisions',
    'appDetailPageLayout.showOtherVersions': 'Show More Revisions',
    'appSearchPageLayout.title': 'Search App',
    'appSearchPageLayout.inputPlaceholder':
      'Search revision, release note and app version',
    'distributionDetailPageLayout.waitingForTester.explanationHeader':
      'Please Wait for the Next Revision',
    'distributionDetailPageLayout.waitingForTester.explanationBody':
      'Your App developer prepares a new revision of App for this {deviceType}.',
    'distributionDetailPageLayout.waitingForTester.laterGuideHeader':
      'Check This Icon Later',
    'distributionDetailPageLayout.waitingForTester.laterGuideBody':
      "Once the next revision is ready, you'll be able to install it from the DeployGate icon appears on your Home screen. Please allow your developer for a while to build the app for you.",
    'distributionDetailPageLayout.displayName':
      'Participating in this test as {displayName}',
    'distributionDetailPageLayout.comment': 'Comment Board',
    'distributionDetailPageLayout.changeDisplayName': 'Change Name',
    'distributionDetailPageLayout.leave': 'Leave This Test',
    'distributionDetailPageLayout.notification': 'Notification Settings',
    'distributionDetailPageLayout.changeNotificationOn':
      'Turn Notifications On',
    'distributionDetailPageLayout.changeNotificationOff':
      'Turn Notifications Off',
    'commentsPageLayout.title': 'Comment',
    'commentsPage.confirm.delete':
      'Are you sure you want to delete this comment?',
    'notificationSettingPageLayout.title': 'Notification Setting',
    'notificationSettingPageLayout.submit': 'Save',
    'notificationSettingPageLayout.remove': 'Remove notification setting',
    'notificationSettingPageLayout.placeholder': 'Email',
    'notificationSettingPage.sendEmailActivation':
      'Sent a confirmation email from DeployGate to {email}.',
    'notificationSettingPage.confirm.delete':
      'Are you sure you want to delete this setting?',
    'emailActivationPage.title': 'Email Confirmation',
    'emailActivationPage.success': 'Successfully activated your email!',
    'emailActivationPage.error.tokenInvalid':
      'This URL is invalid. Please check your email from DeployGate.',
    'invitation.headerTitle': 'Invitation',
    'invitation.invitee': 'Hello {email},',
    'invitation.message':
      'You have been invited to the app {name} by {inviter}.',
    'invitation.signUpHelp': 'Register in just one minute!',
    'invitation.signUpForApp': 'Sign Up and Download',
    'invitation.signUpForGroup': 'Sign Up',
    'invitation.loginHelp': 'Already a DeployGate user?',
    'invitation.login': 'Log In',
    'unavailableInvitation.title': 'This invitation is invalid.',
    'unavailableInvitation.message':
      'This invitation URL is unavailable due to either of the expired or incorrect token.<br></br>Please contact the issuer of this invitation.',
    'unavailableInvitation.back': 'Back to Top',
    'showExceptionError.title': 'Failed to connect.',
    'showExceptionError.subTitle': 'Please try again later.',
    'showExceptionError.back': 'Back',
    'emailValidation.invalid.format':
      'Characters other than ASCII codes are included in the email domain part. Please check again.',
    'error.notSafari.requiredSafari': 'Safari is required to open this page',
    'error.notSafari.openSafari': 'Open Safari',
    'error.notSafari.copyHtml':
      'Please copy and paste{br}the link below into the Safari browser.',
    'error.notSafari.copyUrl': 'Copy',
    'error.hint.cookieOff':
      'Not available when Safari Cookie is disabled. Please enable it from the Settings application.',
    'error.hint.privateBrowser': 'Not available for if private browsing mode.',
    'api.error.distributionNotFound': 'There is no distribution page',
    'api.error.general': 'Failed to connect. Please try again later.',
    'api.error.invalidEmailOrPassword': 'invalid email or password.',
    'api.error.notConnectedToInternet': 'not connected to internet.',
    'api.error.someRequiredParamsIsBlank': 'some required params is blank.',
    'api.error.notAcceptedTerms':
      'Required agree to the Terms of Service and Privacy Policy.',
    'api.error.thisNameIsAlreadyUsed': 'this name is already used.',
    'api.error.thisEmailIsAlreadyUsed': 'this email is already used.',
    'api.error.tokenIsInvalid': 'token is invalid',
    'api.error.noSessionFound': 'no session found',
    'api.error.noEnterpriseFound': 'no enterprise found',
    'api.error.SamlAuthenticationDisabled': 'SAML authentication is not valid',
    'api.error.distributionDisplayNameInvalidCharacters':
      'Only letters, numbers, hyphens and underscores are allowed in a username.',
    'api.error.invalidEmail': 'invalid email',
    'api.error.thisDistributionLimitedAccesses':
      'This distribution has limited people who can access.',
    'api.error.thisIphoneWasLooggedIn':
      'This iPhone/iPad was logged in by other account. Please try to login again.',
    'api.error.notFoundIphone': 'not found iPhone/iPad',
    'api.error.thisEmailIsAlreadyInUse':
      'Unable to use this e-mail. Please try another e-mail.',
    'api.error.theseTransactionKeyAndCodeWereInvalid':
      'Verification of the verification code failed. Please verify your verification code.',
    'api.error.TheTransactionKeyHasBeenInvalidated':
      'The verification code has been invalidated. Please resend a verification code.',
    'api.error.TooManyRequests':
      'Could not accept due to many similar requests. Please try again later.',
    'api.error.SsoAuthDueDateOver':
      'Your device has logged out. The DeployGate account you are currently using needs to be migrated and cannot be used.',
    'api.error.NotFoundOrNeedToLogIn':
      'This distribution no longer exists or you have to log-in to the correct account.',
    'api.error.name.too_short':
      'Username must be between 3 to 20 characters long.',
    'api.error.name.too_long':
      'Username must be between 3 to 20 characters long.',
    'api.error.name.invalid':
      'Only letters, numbers, hyphens and underscores are allowed in a username.',
    'api.error.name.taken': 'This username is available.',
    'api.error.password.length': 'Password must be at least 6 characters long.',
    'api.error.monthlyTransferLimitExceeded':
      'Monthly distribution data limit exceeded. Please upgrade your plan or wait for the next billing cycle.',
  },
};
